<template>
    <div>
        <div class="leaves_top"></div>

        <HeaderMenu_Admin />
        <LateralMenu_Admin />

        <div id="admin-vouchercodes">
            <div class="content">
                <div class="admin-tools header">
                    <a v-on:click="createVouchercode_clicked()">Créér un code promo</a>
                    <router-link to="/admin/logout" v-slot="{ href }">
                        <a v-bind:href="href">Déconnexion</a>
                    </router-link>
                </div>
            </div>

            <div class="list-container content">
                <span class="title">Liste des codes promos en cours de validité</span>
                <div v-for="vouchercode in vouchercodes">
                    <span>{{ vouchercode.code }}</span>
                    <span>
                        <template v-if="vouchercode.max_usage > 0">
                            Utilisé : {{ vouchercode.usage_count }} / {{ vouchercode.max_usage }}
                        </template>
                        <template v-else>
                            Usage illimité
                        </template>
                    </span>
                    <span>
                        <template v-if="vouchercode.amount_type == 'CURRENCY'">
                            Réduction de {{ vouchercode.amount_value }}€
                        </template>
                        <template v-else-if="vouchercode.amount_type == 'DISCOUNT'">
                            Réduction de -{{ vouchercode.amount_value }}%
                        </template>
                        <template v-else>
                            Données indisponibles
                        </template>
                    </span>
                    <div class="tools">
                        <span class="delete" v-on:click="vouchercodeItem_onDeleteClicked(vouchercode)">&#x274C;</span>
                    </div>
                </div>
            </div>
        </div>

        <div id="leaves_sides">
            <div class="left"></div>
            <div class="right"></div>
        </div>

        <CodePromo ref="codepromoPopin" />

        <Footer />
    </div>
</template>

<script>
import HeaderMenu_Admin from '../../components/HeaderMenu_Admin.vue';
import LateralMenu_Admin from '../../components/LateralMenu_Admin.vue';
import Footer from '../../components/Footer.vue';
import CodePromo from '../../components/CodePromo.vue';

import axios from 'axios';

export default {
    name: "Admin_VouchercodesPage",
    components: {
        HeaderMenu_Admin,
        LateralMenu_Admin,
        Footer,
        CodePromo
    },
    data: () => ({
        // giftcards informations
        vouchercodes: null
    }),
    methods: {
        redirect: function(url) {
            window.open(url, '_blank');
        },
        createVouchercode_clicked: function() {
            this.$refs.codepromoPopin.popin_codepromoDisplayed();
        },
        loadVoucherCodes: function() {
            axios.get('https://api.lockquest.fr/voucher_codes')
                .then((response) => {
                    this.vouchercodes = response.data;
                });
        },
        vouchercodeItem_onDeleteClicked: function(vouchercode) {
            var ok = window.confirm('Voulez-vous vraiment supprimer le code promo ' + vouchercode.code + ' ?');
            if (ok) {
                var token = localStorage.getItem('admin-token');
                axios.post('https://api.lockquest.fr/voucher_code', {
                    action: 'delete',
                    data: {
                        code: vouchercode.code
                    }
                }, {
                    headers: {
                        'Authorization': `Basic ` + token,
                        'Content-Type': 'application/x-www-form-urlencoded'
                    }
                }).then((response) => {
                    document.location.reload();
                }).catch((error) => {
                    alert('Une erreur est survenue, merci de contacter notre équipe.');
                });
            }
        }
    },
    mounted() {
        this.loadVoucherCodes();
    }
}
</script>